import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';

import RadioSingle from '../../Input/RadioSingle';
import { ReactComponent as Help } from '../../../assets/icons/icon-help.svg';

import apiDescriptions from '../../../api/Delivery';

import { spanish } from '../../../config/config';

import ImagePlaceholder from '../../Placeholder';
import placeholder from '../../../assets/placeholder/options.jpg';

const Tooltip = ({ text }) => (
  <div className={styles.tooltip}>
    <div>
      <p>{text}</p>
    </div>
  </div>
);

const Option = ({
  idProveedor,
  method,
  time,
  cost,
  shippingTax,
  description,
  onChangeShippingOption,
}) => {
  const [tooltip, setTooltip] = useState(false);
  const showTooltip = () => setTooltip(true);
  const hideTooltip = () => setTooltip(false);
  return (
    <div className={styles.option}>
      <RadioSingle
        name="shipping"
        value={idProveedor}
        onChange={(e) => onChangeShippingOption(e, cost, shippingTax)}
      >
        <span>{`${method} - `}</span>
        <b>{time}</b>
        <span>{` $${cost} MXN`}</span>
      </RadioSingle>
      <button
        type="button"
        className={styles.help}
        onMouseOver={showTooltip}
        onFocus={showTooltip}
        onMouseLeave={hideTooltip}
        onBlur={hideTooltip}
      >
        <Help />
      </button>
      {tooltip ? <Tooltip text={description} /> : ''}
    </div>
  );
};

const Shipping = ({
  content,
  shippingOptions,
  onChangeShippingOption,
  onSubmitShippingForm,
  shippingOption,
}) => {
  const [descriptions, setDescriptions] = useState(null);
  useEffect(async () => {
    setDescriptions(await apiDescriptions.getContent());
  }, []);
  const options = shippingOptions?.map((option) => {
    let description = '';
    if (option?.proveedor.includes('URGENTE')) {
      description = spanish
        ? descriptions?.UrgentSpanish
        : descriptions?.UrgentEnglish;
    } else if (option?.proveedor.includes('MISMO DIA')) {
      description = spanish
        ? descriptions?.SameDaySpanish
        : descriptions?.SameDayEnglish;
    } else if (option?.proveedor.includes('SIGUIENTE')) {
      description = spanish
        ? descriptions?.NextDaySpanish
        : descriptions?.NextDayEnglish;
    } else if (option?.proveedor.includes('DIAS')) {
      description = spanish
        ? descriptions?.SomeDaysSpanish
        : descriptions?.SomeDaysEnglish;
    }
    return (
      <Option
        key={option?.idProveedor}
        method={option?.proveedor_interno}
        time={option?.proveedor}
        cost={option?.baseEnvio}
        shippingTax={option?.ivaCostoEnvio}
        description={description}
        idProveedor={option?.idProveedor}
        onChangeShippingOption={onChangeShippingOption}
      />
    );
  });
  const headText = spanish
    ? content?.MethodTitleSpanish
    : content?.MethodTitleEnglish;
  const warningText = spanish
    ? content?.WarningSpanish
    : content?.WarningEnglish;
  const buttonText = spanish
    ? content?.ContinueButtonSpanish
    : content?.ContinueButtonEnglish;
  const isDisabled = shippingOption === 0;
  return (
    <div className={styles.container}>
      {content && shippingOptions ? (
        <form className={styles.form}>
          <div className={styles.content}>
            <div className={styles.options}>
              <h4>{headText}</h4>
              {options}
            </div>
            <div className={styles.warning}>
              <p>{warningText}</p>
            </div>
            <div className={styles.button}>
              <button
                className={`btn btn-yellow ${isDisabled ? 'disabled' : ''}`}
                type="button"
                onClick={onSubmitShippingForm}
                disabled={isDisabled}
              >
                {buttonText}
              </button>
            </div>
          </div>
        </form>
      ) : (
        <div className={styles.container}>
          <ImagePlaceholder mobile={placeholder} />
        </div>
      )}
    </div>
  );
};
export default Shipping;
